// src/context/LearningContext.jsx
import React, { createContext, useContext } from "react";
import { useLearning } from "../hooks/useLearning";
import { useAllUsers } from "../hooks/useFirestore";

import { EMS_DEPARTMENTS } from "../utils/hrConstants";

const LearningContext = createContext(null);

export function useLearningContext() {
  const ctx = useContext(LearningContext);
  if (!ctx) {
    throw new Error("useLearningContext must be used within a LearningProvider");
  }
  return ctx;
}

export function LearningProvider({ children }) {
  const learningState = useLearning();

  // ── Real employees from Firebase Firestore ──────────────────────────────
  const { data: allUsers, loading: loadingEmployees } = useAllUsers();

  // Active employees only
  const employees = allUsers.filter((u) => u.isActive !== false && u.displayName);

  // Unique departments list derived from real employee records merged with standard EMS_DEPARTMENTS
  const rawDepts = employees.map((e) => e.department || e.departmentId || "").filter(Boolean);
  const departments = [...new Set([...EMS_DEPARTMENTS, ...rawDepts])].sort();

  return (
    <LearningContext.Provider
      value={{
        ...learningState,
        employees,          // Real active Firestore users
        departments,        // Real unique department list
        loadingEmployees,
      }}
    >
      {children}
    </LearningContext.Provider>
  );
}
